import { render } from "./myNoble.vue?vue&type=template&id=7a4a3b3f&scoped=true"
import script from "./myNoble.vue?vue&type=script&lang=js"
export * from "./myNoble.vue?vue&type=script&lang=js"

import "./myNoble.vue?vue&type=style&index=0&id=7a4a3b3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4a3b3f"]])

export default __exports__